export { default } from "./ExternalLink";
